"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var uuid_1 = require("uuid");
var AccessibleDisabledButton = function (_a) {
    var disabled = _a.disabled, className = _a.className, _b = _a.disabledHelperMessage, disabledHelperMessage = _b === void 0 ? 'Please complete all required fields before submitting.' : _b, props = __rest(_a, ["disabled", "className", "disabledHelperMessage"]);
    var id = (0, react_1.useMemo)(function () { return (0, uuid_1.v4)(); }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        disabled && (react_1.default.createElement(Typography_1.default, { variant: 'srOnly', id: id }, disabledHelperMessage)),
        react_1.default.createElement(Button_1.default, __assign({}, props, { className: (0, classnames_1.default)([className, disabled ? 'Mui-disabled' : '']), "aria-disabled": disabled, "aria-describedby": disabled ? id : undefined }))));
};
exports.default = AccessibleDisabledButton;
//# sourceMappingURL=AccessibleDisabledButton.js.map